export interface HaccpsState {
    getTypeProcedureSuccess:any;
    getTypeProcedureError:any;
    getTypeRecordSuccess:any;
    getTypeRecordError:any;
    getHazardTypeSuccess:any;
    getHazardTypeError:any;
    addHazardTypeSuccess:any;
    addHazardTypeError:any;
    createHazardSuccess:any;
    createHazardError:any;
    getAllHazardsSuccess:any;
    getAllHazardsError:any;
    getHazardByIdSuccess:any;
    getHazardByIdError:any;
    getHazardCountSuccess:any;
    getHazardCountError:any;
    hazardSearchSuccess:any;
    hazardSearchError:any;
    getEditHazardSuccess : any;
    getEditHazardError : any;
}
export const InitialHaccpState : HaccpsState = {
    getTypeProcedureSuccess:null,
    getTypeProcedureError:null,
    getTypeRecordSuccess:null,
    getTypeRecordError:null,
    getHazardTypeSuccess:null,
    getHazardTypeError:null,
    addHazardTypeSuccess:null,
    addHazardTypeError:null,
    createHazardSuccess:null,
    createHazardError:null,
    getAllHazardsSuccess:null,
    getAllHazardsError:null,
    getHazardByIdSuccess:null,
    getHazardByIdError:null,
    getHazardCountSuccess:null,
    getHazardCountError:null,
    hazardSearchSuccess:null,
    hazardSearchError:null,
    getEditHazardSuccess :null,
    getEditHazardError :null
}